import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=68b826a8"
import script from "./Node.vue?vue&type=script&lang=js"
export * from "./Node.vue?vue&type=script&lang=js"
import style0 from "./Node.vue?vue&type=style&index=0&id=68b826a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports